import { ServiceResponse } from "~/api/api.types";
import { api } from "./axios";

export const resendVerificationEmail = async ({
  hashedUserId,
  reCaptchaToken,
}: {
  hashedUserId: string;
  reCaptchaToken: string;
}) => {
  const response = await api.post<ServiceResponse<{ message: string }>>(
    `${hashedUserId}/email/verification-notification`,
    {},
    {
      headers: {
        "g-recaptcha-token": reCaptchaToken,
      },
    },
  );
  return response.data;
};
